/**
 * Ordered lowercase weekday keys, Sunday-first, matching the `hoursOfOperation`
 * and `capacityByDayOfWeek` API field names used by `kinetik-trip-service`.
 * Use this as the single source of truth for weekday iteration order.
 */
export const ORDERED_WEEKDAY_KEYS = Object.freeze([
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
]);

/**
 * Maps uppercase weekday names to their 3-letter display abbreviations.
 * Example: `{ SUNDAY: 'SUN', MONDAY: 'MON', ... }`
 * Derived from `ORDERED_WEEKDAY_KEYS` so the order and membership always match.
 */
export const WEEKDAY_SHORT_LABELS = Object.freeze(
  Object.fromEntries(
    ORDERED_WEEKDAY_KEYS.map((key) => [
      key.toUpperCase(),
      key.slice(0, 3).toUpperCase(),
    ]),
  ),
);
